import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { flowRight } from 'lodash';
import ProtectedButton from '../../containers/protected-button';
import LikeButton from '../like-button';
import withTranslate from '../../hoc/with-translate';
import withFontClassName from '../../hoc/with-font-class-name';
import withAuth from '../../hoc/with-auth';
import styles from './comment-footer.scss';

class CommentFooter extends Component {
  handleLikeClick = e => {
    const { comment, onLikeClick } = this.props;
    e.preventDefault();
    if (onLikeClick) {
      onLikeClick({ postId: comment.postId, commentId: comment._id });
    }
  };

  handleReplyClick = e => {
    const { comment, onReplyClick } = this.props;
    e.preventDefault();
    if (onReplyClick) {
      onReplyClick(comment._id);
    }
  };

  renderReplyLink = () => {
    const { t, showReplyLink } = this.props;
    return (
      showReplyLink &&
      <span onClick={this.handleReplyClick} className={classNames(styles.reply, 'comment-footer__reply')}>
        {t('comment.reply')}
      </span>
    );
  };

  render = () => {
    const { comment, t, type, contentFontClassName, forPublicUser } = this.props;
    const className = classNames(styles.container, styles[type], 'forum-text-color', 'comment-footer');
    const likeCount = comment.likeCount || 0;

    return (
      <div className={className}>
        {this.renderReplyLink()}
        <ProtectedButton
          onClick={forPublicUser(this.handleLikeClick, { preventDefault: true })}
          className={classNames(styles.likeButton, contentFontClassName)}
          aria-live="assertive"
        >
          <span className={classNames(styles.likeCount)} data-hook="comment-footer__like-count">
            {t('comment.like-count', { count: likeCount })}
          </span>
          <LikeButton isLiked={comment.isLiked} likeCount={likeCount} isDisabled={comment.isLikeInProgress}/>
        </ProtectedButton>
      </div>
    );
  };
}

CommentFooter.SEARCH = 'search';

CommentFooter.propTypes = {
  comment: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  type: PropTypes.string,
  onLikeClick: PropTypes.func,
  onReplyClick: PropTypes.func,
  showReplyLink: PropTypes.bool,
  contentFontClassName: PropTypes.string.isRequired,
  forPublicUser: PropTypes.func,
};

export default flowRight(withTranslate, withFontClassName, withAuth)(CommentFooter);



// WEBPACK FOOTER //
// ./app/components/comment-footer/comment-footer.js